"use client";

import React, { createContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { GlobalContextProps } from "./types";

export const GlobalContext = createContext<GlobalContextProps>(undefined);

export const GlobalProvider = ({ children }: any) => {
  const [context, setContext] = useState<any>({});
  const [contextCookie, setContextCookie] = useCookies();
  const [authCookie, setAuthCookie, removeCookie] = useCookies([
    "Authorization",
  ]);

  useEffect(() => {
    if (Object.keys(contextCookie).length === 0) {
      setContextCookie("context", {});
    } else {
      setContext({ ...contextCookie.context });
    }
  }, []);

  return (
    <GlobalContext.Provider
      value={{ context, setContext, authCookie, setAuthCookie, removeCookie }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
